<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'">
  <div class="search-container">
    <div class="search-column">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input [(ngModel)]="search.userName" matInput name="name">
      </mat-form-field>

      <ac-input-container label="Security Policies">
        <ac-select
          [(acModel)]="search.securityPolicyId"
          [items]="search.securityPolicies"
          [allowClear]="true"
          [multiple]="true"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>
    </div>
  </div>
</arm-dialog>
